import { useNavigate } from 'react-router-dom';
import { PageOuterContainer } from '../../../../root-components/layouts/page-outer-container'
import ProjectService from '../../../../shared/services/project/project.service';
import { PageHeading } from '../../../presentation-components/display-elements-components/page-heading'
import { ProjectForm } from '../../../presentation-components/organisation-components/project-form'
import { useContext, useState } from 'react';
import { IPostProject } from '../../../../shared/services/project/project.model';
import moment from 'moment';
import { UserNotificationsContext } from '../../../../context/user-notifications/user-notifications';
import { ReportPeriodContext } from '../../../../context/report-periods/report-periods';
import { ScreenLabelsContext } from '../../../../context/screen-labels/screen-labels';

export const OrganisationProjectNewPage = () => {
  const navigate = useNavigate();
  //Services
  const projectService = ProjectService.getInstance()
  const userNotificationsContext = useContext(UserNotificationsContext)
  const reportPeriodContext = useContext(ReportPeriodContext)
  const screenLabelsContext = useContext(ScreenLabelsContext)
  //State
  const [errorMessage, setErrorMessage] = useState<string>()
  const [errorCode, setErrorCode] = useState<number>()
  const [newProject, setNewProject] = useState<IPostProject>({
    summary: '',
    description: '',
    projectReference: '',
    assignedUserId: null,
    startDate: moment(
      reportPeriodContext.allReportPeriods.find(r => r.id === reportPeriodContext.lastSelectedReportId)?.startDate
      ?? moment()
    ).format('YYYY-MM-DD HH:mm:ss.SSS Z'),
    endDate: null,
    customFieldValues: [],
  })
  //Loading State
  const [isFormSubmitting, setIsFormSubitting] = useState<boolean>(false)
  //Component Event Handlers
  const submitHandler = async (newProject: IPostProject) => {
    if (!isFormSubmitting) {
      setIsFormSubitting(true)
      projectService.create(newProject)
        .then(response => {
          setIsFormSubitting(false)
          userNotificationsContext.openSnackbar({ open: true, message: 'Saved successfully' });
          projectService.getAll(undefined, true).catch(() => {});
          navigate(`/organisation/projects/${response.id}`)
        })
        .catch(err => {
          setIsFormSubitting(false)
          console.log(err)
          if (err.response.data.message) {
            setErrorMessage(err.response.data.message)
            setErrorCode(err.response.data.code)
          } else {
            userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
          }
        })
    } else {
      userNotificationsContext.openSnackbar({ open: true, message: 'Saving in progress, please wait' });
    }
  }

  return (
    <PageOuterContainer>
      <PageHeading
        title={`Add New ${screenLabelsContext.getLabel('project', { plural: false, capitalize: 'first' })}`}
        includeBackButton={true}
        backButtonLink='/organisation/projects'
        backButtonText={`Back to ${screenLabelsContext.getLabel('project', { plural: true })}`}
      />
      <ProjectForm
        isSubmitting={isFormSubmitting}
        newProject={newProject}
        submitHandler={submitHandler}
        errorMessage={errorMessage}
        errorCode={errorCode}
        setErrorMessage={setErrorMessage}
        setErrorCode={setErrorCode}
      />
    </PageOuterContainer>
  )
}